var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "mt-header",
        { staticClass: "plain", attrs: { fixed: "" } },
        [
          _c(
            "mt-button",
            {
              attrs: { slot: "left", icon: "back" },
              on: { click: _vm.goBack },
              slot: "left"
            },
            [_vm._v("返回")]
          ),
          _vm._v(" "),
          _c(
            "mt-button",
            {
              attrs: { slot: "right" },
              on: { click: _vm.goBack },
              slot: "right"
            },
            [_vm._v("取消")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "info-block-list text-left" }, [
        _vm.$route.query.type
          ? _c(
              "div",
              { staticClass: "info-block" },
              [
                _c(
                  "mt-loadmore",
                  {
                    ref: "loadMore",
                    attrs: {
                      "auto-fill": false,
                      "top-method": _vm.refresh,
                      "bottom-method": _vm.loadMore,
                      "bottom-all-loaded": _vm.allLoaded
                    },
                    on: { "bottom-status-change": _vm.handleBottomChange }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "info-list" },
                      _vm._l(_vm.data.items, function(item) {
                        return _c(
                          "div",
                          { key: item.infoid, staticClass: "info-item" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "clamp-text",
                                on: {
                                  click: function($event) {
                                    _vm.showInfoDetail(item)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(item.title))]
                            )
                          ]
                        )
                      })
                    )
                  ]
                )
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "info-block" },
              [
                _c(
                  "mt-loadmore",
                  {
                    ref: "loadMore2",
                    attrs: {
                      "auto-fill": false,
                      "top-method": _vm.refresh2,
                      "bottom-method": _vm.loadMore2,
                      "bottom-all-loaded": _vm.allLoaded
                    },
                    on: { "bottom-status-change": _vm.handleBottomChange }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "info-list" },
                      _vm._l(_vm.data.items, function(item) {
                        return item.groupid != null
                          ? _c(
                              "div",
                              { key: item.groupid, staticClass: "info-item" },
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "clampy",
                                        rawName: "v-clampy",
                                        value: 2,
                                        expression: "2"
                                      }
                                    ],
                                    staticClass: "clamp-text"
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.schoolname) +
                                        ":<" +
                                        _vm._s(item.courseName) +
                                        ">新班<" +
                                        _vm._s(item.groupname) +
                                        ">,开班了!"
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      })
                    )
                  ]
                )
              ],
              1
            )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f558579", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f558579","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/information/more.vue
// module id = null
// module chunks = 